export default function trimZero(number: string) {
  return number.replace(/^0/, '');
}
